function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import PropTypes from "prop-types";

var SvgElevadores = function SvgElevadores(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M28.34 29.5H30v1H2v-1h1.34v-27H2v-1h28v1h-1.66v27zM10 18.668V14h1v4.668l1.647-1.64.706.708L11 20.08v.143h-.144l-.356.355-.356-.355H10v-.143l-2.353-2.343.706-.708L10 18.668zm1-11.465v5.02h-1v-5.02l-1.647 1.64-.706-.708 2.853-2.84 2.853 2.84-.706.708L11 7.203zm9.716 3.974c-1.498 0-2.648-1.154-2.648-2.619v-.706c0-1.464 1.15-2.619 2.648-2.619 1.498 0 2.648 1.155 2.648 2.619v.706c0 1.465-1.15 2.619-2.648 2.619zm0-1c.945 0 1.648-.705 1.648-1.619v-.706c0-.913-.703-1.619-1.648-1.619s-1.648.706-1.648 1.619v.706c0 .914.703 1.619 1.648 1.619zm2.648 17.956h-1v-5.6c0-.452.096-.793.302-1.162.055-.098.093-.16.214-.35l.158-.249c.391-.623.553-1.108.553-1.972v-3.111c0-2.088-.492-2.611-1.604-2.611h-2.542c-1.112 0-1.604.523-1.604 2.61V18.8c0 .864.162 1.35.553 1.972l.158.25c.121.19.159.25.214.35.206.368.302.709.302 1.161v5.6h-1v-5.6c0-.274-.05-.45-.175-.674a5.853 5.853 0 00-.185-.302l-.161-.253c-.485-.772-.706-1.436-.706-2.504v-3.111c0-2.627.925-3.611 2.604-3.611h2.542c1.679 0 2.604.984 2.604 3.61V18.8c0 1.068-.221 1.732-.706 2.504l-.161.253c-.11.173-.143.226-.185.302-.126.225-.175.4-.175.674v5.6zM4.34 29.5h23v-27h-23v27z"
  }));
};

SvgElevadores.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgElevadores.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgElevadores;